import { Text, Image } from '@chakra-ui/react'
import Brand from '../../Assets/brand-projecto-cut.png'

export function Logo () {
  return <Image src={Brand} alt="Brand" w="10%" bg="white" borderRadius="10px" />
}
